// Platform admin sidebar items, consumed by every /admin/* view through
// `AdminShell`. Same shape the group admins use (GroupAdminShell) so the
// chrome reads identical between platform-admin and group-scoped admin.

import type { SidebarItem } from '@leanin/ui';
import type { PlatformRole } from '@leanin/shared/views/profile';

export type PlatformAdminSection =
  | 'members'
  | 'invitations'
  | 'broadcasts'
  | 'user-research'
  | 'coach'
  | 'roadmap'
  | 'moderation'
  | 'resources'
  | 'topics'
  | 'page-seo'
  | 'feature-flags'
  | 'dsr';

export const PLATFORM_ADMIN_ITEMS: ReadonlyArray<SidebarItem> = [
  { id: 'members', label: 'Members', icon: 'users', href: '/admin/members' },
  { id: 'invitations', label: 'Invitations', icon: 'send', href: '/admin/invitations' },
  { id: 'broadcasts', label: 'Broadcasts', icon: 'email', href: '/admin/broadcasts' },
  { id: 'user-research', label: 'User research', icon: 'search', href: '/admin/user-research' },
  { id: 'coach', label: 'Coach conversations', icon: 'comment', href: '/admin/coach' },
  { id: 'roadmap', label: 'Roadmap', icon: 'cards', href: '/admin/roadmap' },
  { id: 'moderation', label: 'Moderation', icon: 'flag', href: '/admin/moderation' },
  { id: 'resources', label: 'Resources', icon: 'book', href: '/admin/resources' },
  { id: 'topics', label: 'Resource Topics', icon: 'filter', href: '/admin/topics' },
  { id: 'page-seo', label: 'Page search copy', icon: 'globe', href: '/admin/page-seo' },
  { id: 'feature-flags', label: 'Feature flags', icon: 'settings', href: '/admin/feature-flags' },
  { id: 'dsr', label: 'Data requests', icon: 'shield', href: '/admin/dsr' },
];

// The admin sub-nav the viewer may actually use. Every section except
// Moderation is admin-only server-side (`requireAdmin`); the moderation
// surfaces authorize moderator OR admin (see server `moderation/authz.ts`).
// A moderator therefore sees only Moderation — showing the other entries
// would link them to pages whose API calls 403.
export function platformAdminItemsForRole(
  role: PlatformRole | null,
): ReadonlyArray<SidebarItem> {
  if (role === 'admin') return PLATFORM_ADMIN_ITEMS;
  if (role === 'moderator') {
    return PLATFORM_ADMIN_ITEMS.filter((item) => item.id === 'moderation');
  }
  return [];
}
